import { memo, useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { BzCard, BzHeading } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { clearNewsaDetailsStates, scripWiseNewsData, sectorWiseNewsDetails, updateAnnouncementNewsStatus } from '../../redux/actions/news';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useWFHMessages } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { _handleArrActiveNewsLtp } from '../../controllers';
import { convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId } from '../../utils/global_functions';
import { getScripbyTokenAndMktSegId } from '../../apis';
import { setScripOverviewData } from '../../redux/actions/marketOverview';


const jtenantToken = 1;
const scripNewsPage = 5;

const NewsContent = ({ objActiveNewsData, tab, setSelectedNews, ...props }) => {

    const dispatch = useDispatch();
    const [news, setNews] = useState({});
    const [objLtpDetails, setObjLtpDetails] = useState({ nLtp: 0, nLtpChange: 0, nLtpPercent: 0, exchange: '' });
    const nAnnouncementStatus = useSelector(state => state?.news.nAnnouncementStatus);

    const handleDetails = (objActiveNewsData) => {
        //Vaibhav Singh : BT-107439: 17-11-23: Modal reappearing ssue Fixed: Start
        dispatch(clearNewsaDetailsStates());
        //Vaibhav Singh : BT-107439: 17-11-23: Modal reappearing ssue Fixed: End
        if (objActiveNewsData.odin_code) {
            dispatch(scripWiseNewsData(objActiveNewsData.odin_code, getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId)), scripNewsPage, jtenantToken));
            dispatch(handleModal([{ "HOT_PURSUIT_DATA": true }]));
            setSelectedNews(objActiveNewsData);
        }
        else if (objActiveNewsData.SNo) {
            dispatch(sectorWiseNewsDetails(objActiveNewsData.SNo, jtenantToken));
            dispatch(handleModal([{ "NEWS_DETAILS": true }]));
        }
        else if (tab === 'Announcements') {
            dispatch(updateAnnouncementNewsStatus(objActiveNewsData.id));
        }
    };


    useEffect(() => {
        setNews(objActiveNewsData);
    }, [objActiveNewsData]);


    // Hari K : BT : 107439 dashboard-news LTP functionality-start
    const handleArrActiveNewsLtp = useCallback((arrTouchLineData) => {
        const objLtp = _handleArrActiveNewsLtp(arrTouchLineData, objActiveNewsData);
        if (objLtp !== undefined) {
            setObjLtpDetails(objLtp);
        } else { }
    }, [objActiveNewsData, news, tab, objLtpDetails]);


    useWFHMessages('touchline', (e) => {
        const arrTouchLineData = [...e.detail];
        handleArrActiveNewsLtp(arrTouchLineData);
    });


    useEffect(() => {
        if (tab === "Hot Pursuit") {
            const arrLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastick = arrLastTickData[getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId) + "_" + objActiveNewsData?.nToken];
            if (arrLastick?.length > 0) {
                const objLtp = handleArrActiveNewsLtp(arrLastick);
                if (objLtp !== undefined) {
                    setObjLtpDetails(objLtp);
                } else { }
            }
        } else { }
    }, [tab]);
    // Hari K : BT : 107439 dashboard-news LTP functionality-end

    // Hari K : BT : 107439 dashboard-news scripover view-start
    const handleScripOverView = async (e) => {
        e.stopPropagation();
        const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId)), token: objActiveNewsData?.nToken }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        if (objResp?.data?.result?.length) {
            const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
            await dispatch(setScripOverviewData([...gridFormatData[0]]));
            await dispatch(handleModalData({ rowDetails: gridFormatData[0], mktSegmentToken: getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId) + '_' + objActiveNewsData.odin_code }));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
        }
    };
    // Hari K : BT : 107439 dashboard-news scripover view-end

    return (
        <>
            <BzCard data-testid="test-news-card" id={`${objActiveNewsData?.nSegmentId + '_' + objActiveNewsData?.nToken}`} className='transparent-card cursor-pointer bdr-card-btm' onClick={() => handleDetails(objActiveNewsData)}>
                <Row className='g-0 d-flex align-items-start justify-content-between'>
                    <Col md={8} className='justify-content-start cursor-pointer pe-2'>
                        <BzHeading className='font-medium font-size3 color-text' >{objActiveNewsData.news_content}</BzHeading>
                        {objActiveNewsData?.id !== nAnnouncementStatus || tab === "News" || tab === 'Hot Pursuit' ? <div className='font-regular font-size2 color-subtext mt-2'>{objActiveNewsData?.date_time}</div> : null}
                    </Col>
                    {objActiveNewsData.odin_code ?
                        <Col md={4} className='ps-3 cursor-pointer bdr-lft' onClick={(e) => handleScripOverView(e)}>
                            <div className='font-medium font-size1 color-subtext text-uppercase'>{objLtpDetails?.exchange}</div>
                            <div className='font-medium font-size2 color-primary text-uppercase text-capitalize'>{objActiveNewsData?.symbol}</div>
                            <div className='d-flex flex-row justify-content-start align-items-center mt-1'>
                                <div className='font-regular font-size2 color-text'>{objLtpDetails?.nLtp}</div>
                                <div className={`font-regular font-size2 color-text ms-1 ${objLtpDetails?.nLtpChange > 0 ? "color-positive" : (objLtpDetails?.nLtpChange < 0 ? "color-negative" : '')} `}>{objLtpDetails?.nLtpChange} ({objLtpDetails?.nLtpPercent}%)</div>
                            </div>
                        </Col> : ''}
                    <Col md='auto' className='d-flex justify-content-end'>
                        {(!objActiveNewsData.odin_code && !objActiveNewsData.category_name) ?
                            (objActiveNewsData.id === nAnnouncementStatus ? < div className='icon-16 icon-sort-up icon-dark ms-2' ></div> : < div className='icon-16 icon-sort-down icon-dark ms-2' ></div>) : ''}
                    </Col>
                </Row>
                {objActiveNewsData?.id == nAnnouncementStatus ?
                    <Row className='g-0 mt-2'>
                        <BzHeading className='font-regular font-size2 color-text mb-2'>{objActiveNewsData.memo}</BzHeading>
                        <div className='font-regular font-size2 color-subtext'>{objActiveNewsData?.date_time}</div>
                    </Row> : null
                }
            </BzCard>
        </>
    );
};
export default memo(NewsContent);
